import React, { useEffect, useState } from 'react';
import Sidebar from "./Sidebar";
import APIs from "../../APIs";

const Myprofile = () => {
  const [user, setUser] = useState(null);
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = userData?.user_id;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!user_id) return;

        const res = await APIs.post(
          "user/getUserById",
          { user_id },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("User API response:", res.data);
        // Assuming user data is in res.data.data
        setUser(res.data?.data || null);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    fetchUser();
  }, [user_id]);

  if (!user) {
    return (
      <div className="page-content">
        <div className="container text-center py-5">
          <p>Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Page Content */}
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* Sidebar */}
              <div className="col-lg-3">
                <Sidebar />
              </div>

              {/* Main Profile Content */}
              <div className="col-lg-9">
                <div className="card mt-30">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="profile-about dashboard-bg-box">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="profile-img-1">
                                <img
                                  src={user.profile_image || "images/img-01.png"}
                                  className="img-fluid"
                                  alt={user.full_name || "user"}
                                  id="user-avtar-leftmenu"
                                />
                              </div>
                            </div>
                            <div className="col-md-8">
                              <div className="dashboard-title mb-3">
                                <h5>Profile About</h5>
                              </div>

                              <div className="table-responsive">
                                <table className="table">
                                  <tbody>
                                    <tr>
                                      <td>Name :</td>
                                      <td>{user.full_name || ""}</td>
                                    </tr>
                                    <tr>
                                      <td>Email :</td>
                                      <td>
                                        <a href={`mailto:${user.email}`}>
                                          {user.email || ""}
                                        </a>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Phone Number :</td>
                                      <td>
                                        <a href={`tel:${user.mobile_number}`}>
                                          {user.mobile_number || ""}
                                        </a>
                                      </td>
                                    </tr>
                                    {user.address ?
                                    <tr>
                                      <td>Address :</td>
                                      <td>
                                        {user.address
                                          ? `${user.address}, ${user.city || ""}, ${user.state || ""}, ${user.country || ""}, ${user.zip_code || ""}`
                                          : ""}
                                      </td>
                                    </tr>:null}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Main Content */}
            </div>
          </div>
        </section>
      </div>
      {/* Page Content End */}
    </div>
  );
};

export default Myprofile;
